(function($, d, w) {

	$(w).on(w.ZP_READY, onInit);

	$(w).on('wpcf7:invalid', onInit);

	function onInit() {
		$('*[placeholder]').each(function(index, element){
			var ele = $(element);
			//if(!ele.hasClass("zp-loaded")) {
				//ele.addClass("zp-loaded");
				ele.focus(function() {
					var input = $(this);
					if (input.val() == input.attr('placeholder')) {
						input.val('');
						input.removeClass('placeholder');
					}
				}).blur(function() {
					var input = $(this);
					if (input.val() == '' || input.val() == input.attr('placeholder')) {
						input.addClass('placeholder');
						input.val(input.attr('placeholder'));
					}
				}).blur().parents('form').submit(function() {
					$(this).find('[placeholder]').each(function() {
						var input = $(this);
						if(input.val() == input.attr('placeholder')) {
							input.val('');
						}
					})
				});
			//}
		});
	}

}(jQuery, document, window))